import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { IoIosArrowDown } from "react-icons/io";

const UsefulLinks = ({ active, onActiveAccordion, data }) => {
  const { locale } = useRouter();
  return (
    <div className="col-span-2 mx-auto max-[1200px]:col-span-4 max-[768px]:mx-0 2sm:col-span-8 2sm:bg-zinc-600 2sm:px-2 2sm:rounded-md">
      <div
        onClick={() => onActiveAccordion(active === "help" ? null : "help")}
        className="2sm:flex 2sm:items-center 2sm:justify-between"
      >
        <h2 className="mb-4 text-xl font-bold 2sm:my-2">
          {data?.menu?.[`title-${locale}`]}
        </h2>
        <IoIosArrowDown
          size="24px"
          className={`hidden 2sm:block ${
            active === "help" ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
      <ul className={`flex flex-col ${active !== "help" && "2sm:hidden"}`}>
        {data?.menu?.links?.map((item) => (
          <Link
            href={item?.url}
            key={item?.url}
            className="mb-2 duration-200 hover:text-red hover:translate-x-[-4px]"
          >
            {item?.[`title-${locale}`]}
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default UsefulLinks;
